export const themeConfig = {
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			xl: 1920
		}
	},
	palette: {
		primary: {
			main: '#313131'
		}
	},
	overrides: {
		MuiAppBar: {
			colorPrimary: {
				backgroundColor: '#313131'
			}
		},
		MuiButton: {
			fontFamily: 'Jost',
			containedPrimary: {
				backgroundColor: '#5F9B2D',
				'&:hover': {
					backgroundColor: '#5F9B2D'
				}
			},
			containedSecondary: {
				backgroundColor: '#f50057',
				'&:hover': {
					backgroundColor: '#f50057'
				}
			}
		},
		MuIconButton: {
			colorPrimary: {
				backgroundColor: '#5F9B2D',
				'&:hover': {
					backgroundColor: '#5F9B2D'
				}
			},
			colorSecondary: {
				backgroundColor: '#f50057',
				'&:hover': {
					backgroundColor: '#f50057'
				}
			}
		},

		MuiFab: {
			primary: {
				backgroundColor: '#5F9B2D',
				'&:hover': {
					backgroundColor: '#5F9B2D'
				}
			},
			secondary: {
				backgroundColor: '#f50057',
				'&:hover': {
					backgroundColor: '#f50057'
				}
			}
		},
		MuiBadge: {
			colorPrimary: {
				backgroundColor: '#5F9B2D',
				'&:hover': {
					backgroundColor: '#518029'
				}
			}
		}
	},
	typography: {
		useNextVariants: true
	}
};